import {useLocation, useHistory} from 'react-router-dom';
import {addOrRemoveModalId} from '../utils';
import {modalIdKey} from '../utils/constants';

export type CloseMethod = 'push' | 'replace' | 'goBack';
export type OpenMethod = 'push' | 'replace';

type Options = {
    openMethod?: OpenMethod;
    closeMethod?: CloseMethod;
};

/**
 * const [isOpen, setOpen] = useModalRoute('modayId')
 */
function useModalRoute(
    modalId: string,
    options: Options = {}
): [boolean, (open: boolean) => void] {
    const history = useHistory();
    const location = useLocation();
    const {closeMethod = 'push', openMethod = 'push'} = options;
    const isOpen: boolean = new URLSearchParams(location.search)
        .getAll(modalIdKey)
        .includes(modalId);
    const setOpen = (open: boolean) => {
        history[open ? openMethod : closeMethod](
            addOrRemoveModalId(location, modalId, open)
        );
    };
    return [isOpen, setOpen];
}

export default useModalRoute;
